import { useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Grid, Segment } from "semantic-ui-react";
import LoginRegisterCard from "../../../auth/components/LoginRegisterCard";
import { PublicWrapper } from "../../../../components/PublicWrapper";
import identitySelectors from "../../../../selectors/identity";
import PermitsPayment from "../../components/Payment";

export const PermitsPaymentPage = () => {
  const contentRef = useRef(null);
  const { site, id } = useParams<{ site: string; id: string }>();
  const [success] = useState<boolean>(false);
  const isLoggedIn = identitySelectors.isLoggedIn();

  if (!isLoggedIn) {
    return <LoginRegisterCard />;
  }

  return (
    <PublicWrapper
      homeUrl={`/${site}/public/permits`}
      confirmation={success ? "Success! Your payment has been submitted" : undefined}
      contentRef={contentRef}
    >
      <Grid centered style={{ marginTop: "8px" }}>
        <Grid.Row>
          <Grid.Column computer={10} mobile={16}>
            <PermitsPayment id={id} details={false} />
            <Segment basic textAlign='center'>
              <Button className='button-ghost' as={Link} to={`/${site}/public/permits/list`}>
                Home
              </Button>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </PublicWrapper>
  );
};
